import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useParams, useHistory } from 'react-router-dom';

import SwappingPanel from '../Components/SwappingPanel';
import TransactionHistoryGraphPanel from '../Components/TransactionHistoryPanel';
import LoginModal from '../Components/LoginModal';
import CreateSwapModal from '../Components/CreateSwapModal';
import LatestTransactionsPanel from '../Components/LatestTransactionsPanel';
import CreateYourOwnSwapPanel from '../Components/CreateYourOwnSwapPanel';
import ProjectFieldColab from '../Components/ProjectFieldColab';
import TelegramButtonComponent from '../Components/TelegramButtonComponent';

import PlusSign from '../images/plusSign.png';

import { useIconSwapService } from '../Components/IconSwapService.jsx';

export const ExchangePage = ({ showResponsiveLogin }: ExchangePageProps) => {
  const type: SwapTypeType = useParams();
  const history = useHistory();
  const swapType = type.swapType;
  const { address } = useIconSwapService();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);

  useEffect(() => {
    getWindowDimensions();
    if (!address) return;
    closeAuthModal();
  }, [address]);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const openAuthModal = () => {
    setIsAuthModalOpen(true);
  };

  const openSwapModal = () => {
    setIsSwapModalOpen(true);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  const closeSwapModal = () => {
    setIsSwapModalOpen(false);
  };

  const chooseModal = () => {
    if (width < 416) {
      return !address ? showResponsiveLogin() : history.push('/createSwap');
    }
    !address ? openAuthModal() : openSwapModal();
  };

  const latestTransactionToken = (type?: string) => {
    switch (type) {
      case 'AC3':
        return 'cx9ab3078e72c8d9017194d17b34b1a47b661945ca';
      case 'SPORTS':
        return 'cx08eb683a53d6f244d538a45f0cc584825e2cb985';
      case 'WOK':
        return 'cx921205acb7c51e16d5b7cbc37539a4357d929d20';
      case 'TAP':
        return 'cxc0b5b52c9f8b4251a47e91dda3bd61e5512cd782';
      default:
        return 'cx0000000000000000000000000000000000000000';
    }
  };

  return (
    <>
      <ExchangePageWrapper width={width}>
        <HeadingContentWrapper>
          <HeadingWrapper>
            <MainHeading>{swapType} token exchange</MainHeading>
            <SubHeading>
              Safely buy and sell {swapType} tokens, with ICX.
            </SubHeading>
          </HeadingWrapper>
          <CreateSwapResponsiveWrapper>
            <CreateSwapButton onClick={() => chooseModal()}>
              <PlusSignImage src={PlusSign} alt="plus sign"></PlusSignImage>
              <ButtonText>Create a swap</ButtonText>
            </CreateSwapButton>
          </CreateSwapResponsiveWrapper>
        </HeadingContentWrapper>
        <PanelWrapper>
          <SwappingPanel swapType={swapType} direction={'from'} />
          <Padding />
          <SwappingPanel swapType={swapType} direction={'to'} />
        </PanelWrapper>
        <TransactionHistoryGraphPanelWrapper>
          <TransactionHistoryGraphPanel swapType={swapType} />
        </TransactionHistoryGraphPanelWrapper>
        <BottomPanelWrapper>
          <LatestTransactionsPanel token={latestTransactionToken(swapType)} />
          <Padding />
          <CreateYourOwnSwapPanel
            swapType={swapType}
            createSwap={openSwapModal}
            login={openAuthModal}
            responsiveLogin={showResponsiveLogin}
          />
        </BottomPanelWrapper>
        <ProjectFieldColab />
        <TelegramButtonComponent />
      </ExchangePageWrapper>
      <LoginModal isModalOpen={isAuthModalOpen} closeModal={closeAuthModal} />
      <CreateSwapModal
        isModalOpen={isSwapModalOpen}
        closeModal={closeSwapModal}
      />
    </>
  );
};

export default ExchangePage;

type SwapTypeType = {
  swapType: string;
};

const ExchangePageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  background-color: #f1f8fc;
  height: 2150px;
  ${(props: WidthType) => {
    const setWidth = props.width - 250;
    const setWidthString = setWidth.toString() + 'px';
    return css`
      width: ${setWidthString};
    `;
  }}
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    margin-left: 0;
    width: 100vw;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    padding-bottom: 100px;
    padding-top: 40px;
  }
`;

const HeadingContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 1055px;
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 320px;
  }
`;

const HeadingWrapper = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const MainHeading = styled.h1`
  color: #100f10;
  font-family: 'Tiempos Headline';
  font-size: 38px;
  font-weight: 600;
  @media (max-width: 414px) {
    color: #0e0d0e;
    font-family: 'Tiempos Headline';
    font-size: 22px;
    font-weight: 600;
  }
`;

const SubHeading = styled.span`
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  color: #100f10;
  @media (max-width: 414px) {
    color: #100f10;
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 500;
  }
`;

const CreateSwapResponsiveWrapper = styled.div`
  margin-left: auto;
  @media (max-width: 414px) {
    width: 300px;
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: 0;
  }
`;

const CreateSwapButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 190px;
  border-radius: 4px;
  margin-top: 40px;
  margin-bottom: 40px;
  margin-left: auto;
  @media (max-width: 414px) {
    justify-self: flex-start;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
  }
`;

const PlusSignImage = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
  margin-right: 10px;
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

const PanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 414px) {
    flex-direction: column;
  }
`;

const BottomPanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 40px;
  @media (max-width: 414px) {
    flex-direction: column;
  }
`;

const Padding = styled.div`
  width: 40px;
  min-width: 40px;
  height: 532px;
  @media (max-width: 414px) {
    height: 40px;
    width: 300px;
  }
`;

const TransactionHistoryGraphPanelWrapper = styled.div`
  margin-top: 40px;
`;

type ExchangePageProps = {
  showResponsiveLogin: () => void;
};

type WidthType = {
  width: number;
};
